import { render, staticRenderFns } from "./ItineraryPricingSettings.vue?vue&type=template&id=4e558b23&"
import script from "./ItineraryPricingSettings.vue?vue&type=script&setup=true&lang=js&"
export * from "./ItineraryPricingSettings.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports